import { c as _c } from "react/compiler-runtime";
import { createQueryFn, marketplaceQueryKeys } from '../../../../lib/entry.js';
import { useSuspenseQuery } from '../../../../tanstack/entry.js';
import { getMarketplaceBalance } from '../../../actions/marketplace/getMarketplaceBalance.js';
const fetcher = createQueryFn(getMarketplaceBalance);
/**
 * Gets marketplace balance for a given draw.
 *
 * @param drawNumber Draw number to get marketplace balance for
 * @param product Product to get marketplace balance for
 * @param queryOptions Optional query configuration options
 * @returns Marketplace balance model
 */
export function useGetMarketplaceBalance(drawNumber, product, queryOptions) {
  const $ = _c(9);
  let t0;
  if ($[0] !== drawNumber || $[1] !== product) {
    t0 = marketplaceQueryKeys.marketplaceBalance(product, drawNumber);
    $[0] = drawNumber;
    $[1] = product;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const t1 = queryOptions?.defaultValue;
  let t2;
  if ($[3] !== t1) {
    t2 = fetcher({
      defaultValue: t1
    });
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== queryOptions || $[6] !== t0 || $[7] !== t2) {
    t3 = {
      ...queryOptions,
      queryKey: t0,
      queryFn: t2
    };
    $[5] = queryOptions;
    $[6] = t0;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return useSuspenseQuery(t3);
}